import { useSelector } from "react-redux";

import H2RButton from "./H2RComponents/H2RButton";
import H2RInput from "./H2RComponents/H2RInput";
import H2RSelect from "./H2RComponents/H2RSelect";
import H2RHeading from "./H2RComponents/H2RHeading";

import * as mainActions from "../actions/mainActions";
import * as socketActions from "../actions/socketActions";
import { categories, defaultCategory, settings } from "../appSettings";
import OpenExternal from "./shared/helpers/OpenExternal";

export function SettingsLeft() {
	const store = useSelector((state) => state.main);

	const selectedCategory = store.selectedCategory || defaultCategory;

	return (
		<div className="flex flex-col">
			<H2RHeading type="h3">Settings</H2RHeading>
			{categories?.map((cat) => {
				return (
					<H2RButton
						key={cat}
						text={cat}
						size="small"
						colour={selectedCategory === cat ? "main" : "dark"}
						type={selectedCategory === cat ? "button" : "link"}
						css="mt-2"
						onClick={() => {
							mainActions.chooseSettingCategory(cat);
						}}
					/>
				);
			})}
		</div>
	);
}

export function SettingsRight() {
	const store = useSelector((state) => state.main);

	const selectedCategory = store.selectedCategory || defaultCategory;
	return (
		<section className="px-10 py-8 w-9/12 flex flex-col bg-gray-800 space-y-6">
			<H2RHeading type="h2">{selectedCategory}</H2RHeading>

			{settings.map((setting) => {
				if (setting.category === selectedCategory) {
					return (
						<div className="flex flex-col" key={setting.name}>
							<H2RHeading type="h4">{setting.title}</H2RHeading>
							{setting.type === "select" && (
								<H2RSelect
									colour="light"
									label={setting.help}
									options={setting.options}
									selected={
										store.settings[setting.name] || setting.defaultSelected
									}
									onChange={(choice) => {
										return socketActions.updateSettings({
											[setting.name]: choice,
										});
									}}
								/>
							)}
							{setting.type === "button" && (
								<>
									<span className="mb-1 text-xs font-semibold text-gray-500 ">
										{setting.help}
									</span>
									<H2RButton
										text={setting.buttonText}
										size="small"
										colour="main"
										css="w-min"
										onClick={() => {
											return socketActions.settingsAction(setting.name);
										}}
									/>
								</>
							)}
							{setting.type === "input" && (
								<H2RInput
									colour="light"
									type={setting.inputType || "text"}
									size="small"
									colourPicker={setting.colourPicker || false}
									placeholder={setting.placeholder}
									label={setting.help}
									options={setting.options}
									value={store.settings[setting.name]}
									onChange={(choice) => {
										return socketActions.updateSettings({
											[setting.name]: choice,
										});
									}}
								/>
							)}
							<span>
								{setting.helpLink && (
									<OpenExternal
										buttonText={"Instructions"}
										isElectronLink={setting.helpLink}
										isNotElectronLink={setting.helpLink}
									/>
								)}
							</span>
						</div>
					);
				}
			})}
		</section>
	);
}
